const RESTRICTED_SHIPPING_CATEGORY = 'RESTRICTED_SHIPPING';

export function isRestrictedShipping(shippingCategory?: string | null): boolean {
  return shippingCategory === RESTRICTED_SHIPPING_CATEGORY;
}
